/**
 * Typed boundary over the untyped `FetchApi` helpers for the Courses screen.
 */
import ApiNames from "../constants/ApiNames";
import { apiClient } from "./NetworkService";
import type {
  ApiResponse,
  Course,
  CourseCardData,
  IdTitle,
  Subject,
} from "../types/courses";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const withSubscriber = (
  endpoint: string,
  subscriberId: string | null
): string =>
  subscriberId ? `${endpoint}&subscriberId=${subscriberId}` : endpoint;

export const getGrades = async (token?: string): Promise<ApiResponse<IdTitle[]>> => {
  const res = await apiClient.get(ApiNames.getLevels, getHeaders(token));
  return res.data;
};

export const getCategories = async (token?: string): Promise<ApiResponse<IdTitle[]>> => {
  const res = await apiClient.get(ApiNames.categories, getHeaders(token));
  return res.data;
};

export const getCoursesByCategory = async (
  categoryId: number,
  subscriberId: string | null,
  token?: string
): Promise<ApiResponse<Course[]>> => {
  const res = await apiClient.get(
    withSubscriber(`${ApiNames.courseByCat}?category_id=${categoryId}`, subscriberId),
    getHeaders(token)
  );
  return res.data;
};

export const getCollarVideos = async (
  courseId: number | string | null,
  subscriberId: string | null,
  token?: string
): Promise<ApiResponse<CourseCardData[]>> => {
  const res = await apiClient.get(
    withSubscriber(`${ApiNames.colarVideo}?course_id=${courseId}`, subscriberId),
    getHeaders(token)
  );
  return res.data;
};

export const getSubjectsByGrade = async (
  levelId: number,
  subscriberId: string | null,
  token?: string
): Promise<ApiResponse<Subject[]>> => {
  const res = await apiClient.get(
    withSubscriber(
      `${ApiNames.courses}?select=topics&type=&levelId=${levelId}`,
      subscriberId
    ),
    getHeaders(token)
  );
  return res.data;
};
